import TracetestAPI from './Tracetest.api';

// eslint-disable-next-line no-restricted-exports
export {default} from './Tracetest.api';

const {
  useGetDataStoreQuery,
  useTestConnectionMutation,
  useUpdateDataStoreMutation,

  useCreateVariableSetMutation,
  useDeleteVariableSetMutation,
  useGetVariableSetsQuery,
  useUpdateVariableSetMutation,

  useParseExpressionMutation,

  useGetResourcesQuery,
  useGetResourceDefinitionQuery,
  useLazyGetResourceDefinitionQuery,

  useGetConfigQuery,
  useGetPollingQuery,
  useGetDemoQuery,
  useGetLinterQuery,
  useGetTestRunnerQuery,
  useCreateSettingMutation,
  useUpdateSettingMutation,

  useCreateTestMutation,
  useGetTestByIdQuery,
  useGetTestVersionByIdQuery,
  useGetTestListQuery,
  useDeleteTestByIdMutation,
  useEditTestMutation,

  useGetRunByIdQuery,
  useGetRunEventsQuery,
  useGetRunListQuery,
  useGetSelectedSpansQuery,
  useLazyGetSelectedSpansQuery,
  useRunTestMutation,
  useReRunMutation,
  useLazyGetRunListQuery,
  useDryRunMutation,
  useDeleteRunByIdMutation,
  useStopRunMutation,
  useSkipPollingMutation,
  useGetJUnitByRunIdQuery,
  useLazyGetJUnitByRunIdQuery,

  useCreateTestSuiteMutation,
  useGetTestSuiteByIdQuery,
  useGetTestSuiteVersionByIdQuery,
  useLazyGetTestSuiteByIdQuery,
  useDeleteTestSuiteByIdMutation,
  useEditTestSuiteMutation,
  useLazyGetTestSuiteVersionByIdQuery,

  useDeleteTestSuiteRunByIdMutation,
  useGetTestSuiteRunByIdQuery,
  useGetTestSuiteRunsQuery,
  useRunTestSuiteMutation,
  useLazyGetTestSuiteRunsQuery,
  useLazyGetTestSuiteRunByIdQuery,
  useGetWizardQuery,
  useUpdateWizardMutation,
  useLazyTestOtlpConnectionQuery,
  useTestOtlpConnectionQuery,
  useResetTestOtlpConnectionMutation,
  useGetSearchedSpansMutation,

  endpoints,
} = TracetestAPI.instance;

export {
  useGetDataStoreQuery,
  useTestConnectionMutation,
  useUpdateDataStoreMutation,
  useCreateVariableSetMutation,
  useDeleteVariableSetMutation,
  useGetVariableSetsQuery,
  useUpdateVariableSetMutation,
  useParseExpressionMutation,
  useGetResourcesQuery,
  useGetResourceDefinitionQuery,
  useLazyGetResourceDefinitionQuery,
  useGetConfigQuery,
  useGetPollingQuery,
  useGetDemoQuery,
  useGetLinterQuery,
  useGetTestRunnerQuery,
  useCreateSettingMutation,
  useUpdateSettingMutation,
  useCreateTestMutation,
  useGetTestByIdQuery,
  useGetTestVersionByIdQuery,
  useGetTestListQuery,
  useDeleteTestByIdMutation,
  useEditTestMutation,
  useGetRunByIdQuery,
  useGetRunEventsQuery,
  useGetRunListQuery,
  useGetSelectedSpansQuery,
  useLazyGetSelectedSpansQuery,
  useRunTestMutation,
  useReRunMutation,
  useLazyGetRunListQuery,
  useDryRunMutation,
  useDeleteRunByIdMutation,
  useStopRunMutation,
  useSkipPollingMutation,
  useGetJUnitByRunIdQuery,
  useLazyGetJUnitByRunIdQuery,
  useCreateTestSuiteMutation,
  useGetTestSuiteByIdQuery,
  useGetTestSuiteVersionByIdQuery,
  useLazyGetTestSuiteByIdQuery,
  useDeleteTestSuiteByIdMutation,
  useEditTestSuiteMutation,
  useLazyGetTestSuiteVersionByIdQuery,
  useDeleteTestSuiteRunByIdMutation,
  useGetTestSuiteRunByIdQuery,
  useGetTestSuiteRunsQuery,
  useRunTestSuiteMutation,
  useLazyGetTestSuiteRunsQuery,
  useLazyGetTestSuiteRunByIdQuery,
  useGetWizardQuery,
  useUpdateWizardMutation,
  useLazyTestOtlpConnectionQuery,
  useTestOtlpConnectionQuery,
  useResetTestOtlpConnectionMutation,
  useGetSearchedSpansMutation,
  endpoints,
};
